<template>
    <div class="tip">
        <div v-bind:class="[status?'success':'error','animate']">{{message}}</div>
    </div>
</template>
<script>
export default {
  name: "Tip",
  props: ["status", "message"],
  data() {
    return {};
  },
  mounted: function() {
    setTimeout(_ => {
      this.$store.commit("getIfShowMessage", false);
    }, 4000);
  }
};
</script>
<style scoped>
.tip {
  position: fixed;
  padding: 20px;
  text-align: center;
  margin: 0 auto;
  z-index: 1;
  top: 100px;
  left: 50%;
  transform: translateX(-50%);
}
.error {
  background: #ff5b5b;
}
.success {
  background: #339900;
}
.animate {
  padding: 0.1rem;
  margin: 0 auto;
  border-radius: 5px;
  color: #fff;
  font-size: 14px;
  animation: mymove 5s;
}

@keyframes mymove {
  0% {
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@-webkit-keyframes mymove /*Safari and Chrome*/ {
  0% {
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/common/tip.vue